export default __webpack_public_path__ + "static/15-d64ec7b8d611c8dc627a7c3c55440220.svg";